import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/output.css"
import axios from "axios";
axios.defaults.baseURL = '/api'
Vue.prototype.$axios= axios
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(ElementUI);
new Vue({
  render: h => h(App),
}).$mount('#app')
